export const isoTimeRegex = /[0-2][0-9]:[0-5][0-9]:[0-5][0-9]/

export function incrementMinuteSelection(isoTime: string, minuteIncrements: string[]): string {
  if (!isoTimeRegex.test(isoTime)) {
    throw new Error(
      `Input time must be a valid ISO time string of the format HH:MM:SS but was ${isoTime}`,
    )
  }

  const [hour, minute] = isoTime.split(':')
  if (!minuteIncrements.includes(minute)) {
    throw new Error(
      `Input time must have a minute value from the specified minute increments but was ${isoTime}`,
    )
  }

  const minuteIndex = minuteIncrements.indexOf(minute)
  if (minuteIndex === minuteIncrements.length - 1) {
    // roll over the hour
    const newHour = parseInt(hour) + 1
    return `${newHour.toString().length === 1 ? '0' : ''}${newHour}:${minuteIncrements[0]}:00`
  }

  return `${hour}:${minuteIncrements[minuteIndex + 1]}:00`
}
